module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasWorldStore) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList && _vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: String(sa.sellerId),
      staticClass: "item",
      class: {
        selected: _vm.isSellerSelected(sa.sellerId)
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.isSellerSelected(sa.sellerId)) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries && _vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c === 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.getMarketplaceSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-alerts-page"
  }, [_c('div', {
    staticClass: "alerts-content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-state"
  }, [_c('i', {
    staticClass: "spinner loading icon"
  }), _vm._v(" "), _c('p', [_vm._v("Loading issues...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('h3', [_vm._v("Failed to load issues")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.fetchIssues
    }
  }, [_vm._v("Retry")])]) : [_c('div', {
    staticClass: "alerts-header"
  }, [_c('div', {
    staticClass: "header-info"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Issues")]), _vm._v(" "), _c('span', {
    staticClass: "total-count"
  }, [_vm._v(_vm._s(_vm.totalAlerts) + " total alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStatus),
      expression: "filterStatus"
    }],
    staticClass: "filter-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "suppressed"
    }
  }, [_vm._v("Suppressed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lost"
    }
  }, [_vm._v("Lost to Competitor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "contested"
    }
  }, [_vm._v("Contested")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "owned"
    }
  }, [_vm._v("Owned")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }, {
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search alerts..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "export-button",
    attrs: {
      "disabled": _vm.exporting
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n          " + _vm._s(_vm.exporting ? 'Exporting…' : 'Export CSV') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "alerts-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("PRODUCT")]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.sortHeadClass('status'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by Status"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onSort('status')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onSort('status')
      }
    }
  }, [_vm._v("\n                STATUS\n                "), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.sortBy === 'status' && _vm.sortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.sortBy === 'status' && _vm.sortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', {
    staticClass: "th-sort"
  }, [_c('span', {
    staticClass: "sort-col-head",
    class: _vm.sortHeadClass('impact'),
    attrs: {
      "role": "button",
      "tabindex": "0",
      "title": "Sort by Est. Daily"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onSort('impact')
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onSort('impact')
      }
    }
  }, [_vm._v("\n                EST. DAILY\n                "), _c('span', {
    staticClass: "sort-col-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.sortBy === 'impact' && _vm.sortDir === 'asc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 8l7 9H5z"
    }
  })]) : (_vm.sortBy === 'impact' && _vm.sortDir === 'desc') ? _c('svg', {
    staticClass: "sort-icon-filled",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 16l-7-9h14z"
    }
  })]) : _c('svg', {
    staticClass: "sort-icon-neutral",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
    }
  })])])])]), _vm._v(" "), _c('th', [_vm._v("ACTION")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedAlerts), function(alert, index) {
    return _c('tr', {
      key: index,
      staticClass: "alert-row"
    }, [_c('td', {
      staticClass: "product-cell",
      on: {
        "click": function($event) {
          return _vm.viewProductDetails(alert.productId || alert.id)
        }
      }
    }, [_c('div', {
      staticClass: "product-image-wrap"
    }, [_c('div', {
      staticClass: "product-image-placeholder"
    }), _vm._v(" "), (alert.imageUrl) ? _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": alert.imageUrl,
        "alt": alert.product
      },
      on: {
        "error": function (e) { return e.target.style.display = 'none'; }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('div', {
      staticClass: "product-name-line"
    }, [_c('span', {
      staticClass: "product-name clickable"
    }, [_vm._v(_vm._s(alert.product))])]), _vm._v(" "), (alert.asin) ? _c('span', {
      staticClass: "product-asin"
    }, [_vm._v(_vm._s(alert.asin))]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "status-cell"
    }, [_c('span', {
      staticClass: "alert-status",
      class: alert.statusType
    }, [_vm._v(_vm._s(alert.status))])]), _vm._v(" "), _c('td', {
      staticClass: "impact-cell"
    }, [_c('span', {
      staticClass: "impact-value",
      class: alert.impactClass
    }, [_vm._v(_vm._s(alert.impact))])]), _vm._v(" "), _c('td', {
      staticClass: "action-cell"
    }, [_c('a', {
      staticClass: "view-details-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleActionButton(alert)
        }
      }
    }, [_vm._v("\n                View Details >\n              ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('div', {
    staticClass: "pagination-info"
  }, [_vm._v("\n        Showing " + _vm._s(_vm.startIndex + 1) + "-" + _vm._s(_vm.endIndex) + " of " + _vm._s(_vm.totalAlerts) + " alerts\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-controls"
  }, [_c('button', {
    staticClass: "pagination-button",
    attrs: {
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('i', {
    staticClass: "chevron left icon"
  }), _vm._v("\n          Previous\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-numbers"
  }, _vm._l((_vm.visiblePages), function(page) {
    return _c('button', {
      key: page,
      class: ['page-number', {
        active: page === _vm.currentPage
      }],
      on: {
        "click": function($event) {
          return _vm.goToPage(page)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page) + "\n          ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "pagination-button",
    attrs: {
      "disabled": _vm.currentPage >= _vm.totalPages
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("\n          Next\n          "), _c('i', {
    staticClass: "chevron right icon"
  })])])])]], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2761d1c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllAlertsPage.vue
// module id = 735
// module chunks = 2